import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PageHero from '../../MyComponents/LandingSections/PageHero';
import LandingSection from '../../MyComponents/LandingSections/LandingSection';
import SectionHeading from '../../MyComponents/LandingSections/SectionHeading';
import HomePricing from '../Home/HomePricing/HomePricing';
import HomeFaq from '../Home/HomeFaq/HomeFaq';
import HomeSchools from '../Home/HomeSchools/HomeSchools';
import HomeContact from '../Home/HomeContact/HomeContact';
import PlanComparison from './PlanComparison';
import SubscriptionsDigitaliada from './SubscriptionsDigitaliada';
import { SPECIAL_QUOTA_LINK, START_FREE_LINK } from '../../common/urlLinks';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

// Signed in, the pricing band is the page's own heading.
const LOGGED_IN_HEADING = {
    eyebrow: 'redesign.pricing.loggedIn.eyebrow',
    title: 'redesign.pricing.loggedIn.title',
    lead: 'redesign.pricing.loggedIn.lead',
};

const useStyles = makeStyles(() => ({
    teamsCta: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '52px',
        padding: '0 26px',
        borderRadius: '999px',
        color: REDESIGN_COLORS.white,
        background: REDESIGN_COLORS.primary,
        fontSize: '1rem',
        fontWeight: REDESIGN_FONTS.weightHeading,
        '&:hover': {
            color: REDESIGN_COLORS.white,
            background: REDESIGN_COLORS.primaryHover,
        },
    },
    teamsCtaRow: {
        display: 'flex',
        justifyContent: 'center',
    },
}));

/**
 * Inside Microsoft Teams the product ships with base features only, so the
 * page is a pointer to the web app and to the quote form.
 */
const TeamsNotice = () => {
    const classes = useStyles();

    return (
        <LandingSection id="preturi" paddingTop={56} paddingBottom={64}>
            <SectionHeading
                title={<FormattedMessage id="topMenu.teams.subscriptions.name" />}
                lead={
                    <>
                        <FormattedMessage id="subscriptions.teams.subscription.description1" />{' '}
                        <FormattedMessage id="subscriptions.teams.subscription.description2" />
                    </>
                }
                marginBottom={28}
            />
            <div className={classes.teamsCtaRow}>
                <Link to={SPECIAL_QUOTA_LINK} className={classes.teamsCta}>
                    <FormattedMessage id="subscriptions.subscription.requestSpecialQuote" />
                </Link>
            </div>
        </LandingSection>
    );
};

/**
 * The plans page, on the landing's primitives. Signed out it is a marketing
 * page: hero, plans, comparison, FAQ, the school pilot and a closing CTA.
 * Signed in (it also renders inside the app drawer) it is the account's plan
 * page: the plan cards reflect the current subscription, then the comparison
 * and the FAQ.
 */
const Subscriptions = ({ profile, language }) => {
    if (window.disableTracking) {
        return <SubscriptionsDigitaliada language={language} />;
    }
    if (window.isTeams) {
        return <TeamsNotice />;
    }

    const loggedIn = Boolean(profile && profile.loggedIn);

    return (
        <>
            {loggedIn ? null : (
                <PageHero
                    keyPrefix="redesign.pricing.hero"
                    primaryTo={START_FREE_LINK}
                    secondaryTo={SPECIAL_QUOTA_LINK}
                    trust={['noCard', 'cancel', 'billing']}
                />
            )}
            {/* Signed out, the hero above is the heading; signed in, the band carries its own. */}
            <HomePricing heading={loggedIn ? LOGGED_IN_HEADING : null} />
            <PlanComparison />
            <HomeFaq />
            {loggedIn ? null : (
                <>
                    <HomeSchools />
                    <HomeContact />
                </>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(Subscriptions);
